module.exports = __webpack_public_path__ + "static/media/1 39 viste.6dddcdda.mp3";